module.exports = __webpack_public_path__ + "static/toron-842551246f1b941eb3de003a1e9d4337.jpg";